<div class="request-details-container d-flex flex-column gap-4" *ngIf="isDataLoaded">
    <div class="d-flex align-items-start">
        <div class="request-details-header flex-grow-1 d-flex flex-column mb-3">
            <div class="d-flex align-items-center gap-3 mb-2">
                <button class="btn link-btn btn-back">
                    <i class="app-icon icon icon-chevron-left icon-xl" (click)="redirectListHandler()"></i>
                </button>
                <div class="request-details-type fw-bold">
                    {{clientDataRequest.dictionaryClientDataRequestType.value}}
                </div>
            </div>
    
            <div>
                {{'requests.details.category.dateOfRequest' | translate}}
                <span HJSuppress>{{clientDataRequest.createdOn | localizedDate}}</span>
            </div>
            <div>
                {{'requests.details.category.requestInitiatedBy' | translate}}:
                <span HJSuppress class="fw-bold">{{ clientDataRequest.createdByName | titlecase }}</span>
            </div>
        </div>

        <ng-container *ngIf="!isAdmin || clientDataRequest.dictionaryRequestStatus?.code===dictionaryRequestStatus.CLOSED">
            <div class="status-box">
                <div class="status-content">
                    <div class="status-dot" 
                        [ngClass]="clientDataRequest.dictionaryRequestStatus?.code===dictionaryRequestStatus.POSTED ? 'status-posted':
                                clientDataRequest.dictionaryRequestStatus?.code===dictionaryRequestStatus.IN_PROGRESS ? 'status-in-progress': 
                                clientDataRequest.dictionaryRequestStatus?.code=== dictionaryRequestStatus.RESOLVED ? 'status-resolved': 
                                clientDataRequest.dictionaryRequestStatus?.code===dictionaryRequestStatus.CLOSED ? 'status-closed': ''">
                    </div>
                    <div class="status-value status-value-lg">{{ clientDataRequest.dictionaryRequestStatus?.value}}</div>
                </div>
            </div>
        </ng-container>
        
        <ng-container *ngIf="isAdmin && clientDataRequest.dictionaryRequestStatus?.code!==dictionaryRequestStatus.CLOSED">
            <div class="status-box">
                <kendo-dropdownlist HJSuppress
                    id="status-dropdownlist" 
                    class="custom-kendo-control-xl request-status-dropdown k-picker-fill-none"
                    [fillMode]="fillModeNone" 
                    [rounded]="roundedLarge"
                    [size]="sizeLarge"
                    [(ngModel)]="statusId"
                    [data]="statuses"
                    [textField]="'value'"
                    [valueField]="'id'"
                    [valuePrimitive]="true"
                    [popupSettings]="{popupClass: 'request-status-dropdown-popup data-hj-suppress', appendTo : 'component'}"
                    (ngModelChange)="changeClientDataRequestStatus($event)"
                >
                    <ng-template kendoDropDownListValueTemplate kendoDropDownListItemTemplate let-status>
                        <div class="status-content">
                            <div class="status-dot"
                                [ngClass]="{
                                    'status-posted': status?.code === dictionaryRequestStatus.POSTED,
                                    'status-in-progress': status?.code === dictionaryRequestStatus.IN_PROGRESS,
                                    'status-resolved': status?.code === dictionaryRequestStatus.RESOLVED,
                                    'status-closed': status?.code === dictionaryRequestStatus.CLOSED,
                                    'status-default': ![dictionaryRequestStatus.POSTED, dictionaryRequestStatus.IN_PROGRESS, dictionaryRequestStatus.RESOLVED, dictionaryRequestStatus.CLOSED].includes(status?.code)
                                }"
                            ></div>
                            <div class="status-value status-value-lg">{{ status?.value }}</div>
                        </div>
                    </ng-template>
                </kendo-dropdownlist>
            </div>
        </ng-container>
    </div>

    <request-detail-category-selector class="mb-3" [selectedCategory]="selectedCategory"
        (categoryChange)="categoryChangeHandler($event)">
    </request-detail-category-selector>

    @switch (selectedCategory) {
    @case (REQUEST_DETAIL_CATEGORY.INFO){
    <div class="card">
        <div class="card-body">
            <div *ngIf="clientDataRequest.dictionaryClientDataRequestType.code === typesEnum.Address">
                <div class="l-section">
                    <span class="l-section-title">{{'requests.clientData.details.homeAddress' | translate}}</span>

                    <ul class="l-section-values">
                        <li class="l-info-value">
                            <span>
                                <span class="l-info-value-label">
                                    {{'requests.clientData.details.country' | translate}}:
                                </span>
                                <span HJSuppress>{{clientDataRequest.addresses[0].country | replaceIfNull}}</span>
                            </span>
                        </li>

                        <li class="l-info-value">
                            <span>
                                <span class="l-info-value-label">
                                    {{'requests.clientData.details.state' | translate}}:
                                </span>
                                <span HJSuppress>{{clientDataRequest.addresses[0].state | replaceIfNull}}</span>
                            </span>
                        </li>
                        <li class="l-info-value">
                            <span>
                                <span class="l-info-value-label">
                                    {{'requests.clientData.details.city' | translate}}:
                                </span>
                                <span HJSuppress>{{clientDataRequest.addresses[0].city | replaceIfNull}}</span>
                            </span>
                        </li>
                        <li class="l-info-value">
                            <span>
                                <span class="l-info-value-label">
                                    {{'requests.clientData.details.street' | translate}}:
                                </span>
                                <span HJSuppress>{{clientDataRequest.addresses[0].streetName | replaceIfNull}}</span>
                                <span HJSuppress>{{clientDataRequest.addresses[0].streetNumber | replaceIfNull}}</span>
                            </span>
                        </li>
                        <li class="l-info-value">
                            <span>
                                <span class="l-info-value-label">
                                    {{'requests.clientData.details.postalCode' | translate}}:
                                </span>
                                <span HJSuppress>{{clientDataRequest.addresses[0].postalCode | replaceIfNull}}</span>
                            </span>
                        </li>
                        <li class="l-info-value">
                            <span>
                                <span class="l-info-value-label">
                                    {{'requests.clientData.details.buildingNumber' | translate}}:
                                </span>
                                <span HJSuppress>{{clientDataRequest.addresses[0].buildingNumber | replaceIfNull}}</span>
                            </span>
                        </li>
                        <li class="l-info-value">
                            <span>
                                <span class="l-info-value-label">
                                    {{'requests.clientData.details.stair' | translate}}:
                                </span>
                                <span HJSuppress>{{clientDataRequest.addresses[0].stair | replaceIfNull}}</span>
                            </span>
                        </li>
                        <li class="l-info-value">
                            <span>
                                <span class="l-info-value-label">
                                    {{'requests.clientData.details.floor' | translate}}:
                                </span>
                                <span HJSuppress>{{clientDataRequest.addresses[0].floor | replaceIfNull}}</span>
                            </span>
                        </li>
                        <li class="l-info-value">
                            <span>
                                <span class="l-info-value-label">
                                    {{'requests.clientData.details.flatNumber' | translate}}:
                                </span>
                                <span HJSuppress>{{clientDataRequest.addresses[0].flatNumber | replaceIfNull}}</span>
                            </span>
                        </li>
                    </ul>
                </div>

                <div class="l-section" *ngIf="clientDataRequest.addresses[1]">
                    <span class="l-section-title">{{'requests.clientData.details.mailingAddress' | translate}}</span>

                    <ul class="l-section-values">
                        <li class="l-info-value">
                            <span>
                                <span class="l-info-value-label">
                                    {{'requests.clientData.details.country' | translate}}:
                                </span>
                                <span HJSuppress>{{clientDataRequest.addresses[1].country | replaceIfNull}}</span>
                            </span>
                        </li>

                        <li class="l-info-value">
                            <span>
                                <span class="l-info-value-label">
                                    {{'requests.clientData.details.state' | translate}}:
                                </span>
                                <span HJSuppress>{{clientDataRequest.addresses[1].state | replaceIfNull}}</span>
                            </span>
                        </li>
                        <li class="l-info-value">
                            <span>
                                <span class="l-info-value-label">
                                    {{'requests.clientData.details.city' | translate}}:
                                </span>
                                <span HJSuppress>{{clientDataRequest.addresses[1].city | replaceIfNull}}</span>
                            </span>
                        </li>
                        <li class="l-info-value">
                            <span>
                                <span class="l-info-value-label">
                                    {{'requests.clientData.details.street' | translate}}:
                                </span>
                                <span HJSuppress>{{clientDataRequest.addresses[1].streetName | replaceIfNull}}</span>
                                <span HJSuppress>{{clientDataRequest.addresses[1].streetNumber | replaceIfNull}}</span>
                            </span>
                        </li>
                        <li class="l-info-value">
                            <span>
                                <span class="l-info-value-label">
                                    {{'requests.clientData.details.postalCode' | translate}}:
                                </span>
                                <span HJSuppress>{{clientDataRequest.addresses[1].postalCode | replaceIfNull}}</span>
                            </span>
                        </li>
                        <li class="l-info-value">
                            <span>
                                <span class="l-info-value-label">
                                    {{'requests.clientData.details.buildingNumber' | translate}}:
                                </span>
                                <span HJSuppress>{{clientDataRequest.addresses[1].buildingNumber | replaceIfNull}}</span>
                            </span>
                        </li>
                        <li class="l-info-value">
                            <span>
                                <span class="l-info-value-label">
                                    {{'requests.clientData.details.stair' | translate}}:
                                </span>
                                <span HJSuppress>{{clientDataRequest.addresses[1].stair | replaceIfNull}}</span>
                            </span>
                        </li>
                        <li class="l-info-value">
                            <span>
                                <span class="l-info-value-label">
                                    {{'requests.clientData.details.floor' | translate}}:
                                </span>
                                <span HJSuppress>{{clientDataRequest.addresses[1].floor | replaceIfNull}}</span>
                            </span>
                        </li>
                        <li class="l-info-value">
                            <span>
                                <span class="l-info-value-label">
                                    {{'requests.clientData.details.flatNumber' | translate}}:
                                </span>
                                <span HJSuppress>{{clientDataRequest.addresses[1].flatNumber | replaceIfNull}}</span>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>

            <div *ngIf="clientDataRequest.dictionaryClientDataRequestType.code === typesEnum.ContactInfo">
                <div class="l-section">
                    <span class="l-section-title">{{'requests.clientData.details.email' | translate}}</span>

                    <ul class="l-section-values">
                        <li HJSuppress class="l-info-value">
                            {{clientDataRequest.contactInformation.email | replaceIfNull}}
                        </li>
                    </ul>
                </div>

                <div class="l-section">
                    <span class="l-section-title">{{'requests.clientData.details.phone' | translate}}</span>

                    <ul class="l-section-values">
                        <li HJSuppress class="l-info-value">
                            {{clientDataRequest.contactInformation.phone}}
                        </li>
                    </ul>
                </div>

                <div class="l-section" *ngIf="clientDataRequest.contactInformation.fax">
                    <span class="l-section-title">{{'requests.clientData.details.fax' | translate}}</span>

                    <ul class="l-section-values">
                        <li HJSuppress class="l-info-value">
                            {{clientDataRequest.contactInformation.fax}}
                        </li>
                    </ul>
                </div>
            </div>

            <div *ngIf="clientDataRequest.dictionaryClientDataRequestType.code === typesEnum.Owner">
                <div class="l-section">
                    <span class="l-section-title">{{'requests.clientData.details.name' | translate}}</span>

                    <ul class="l-section-values">
                        <li HJSuppress class="l-info-value">
                            {{clientDataRequest.beneficialOwner.name | replaceIfNull}}
                        </li>
                    </ul>
                </div>

                <div class="l-section">
                    <span class="l-section-title">{{'requests.clientData.details.phone' | translate}}</span>

                    <ul class="l-section-values">
                        <li HJSuppress class="l-info-value">
                            {{clientDataRequest.beneficialOwner.phone | replaceIfNull}}
                        </li>
                    </ul>
                </div>
            </div>

            <div *ngIf="clientDataRequest.dictionaryClientDataRequestType.code === typesEnum.Associates">
                <div class="l-section" *ngFor="let associate of clientDataRequest.associates">
                    <span HJSuppress class="l-section-title">{{associate.name | replaceIfNull}}</span>

                    <ul HJSuppress class="l-section-values">
                        <li class="l-info-value">
                            {{'requests.clientData.details.companyPercentage' | translate}}:
                            {{associate.companyPercentage | replaceIfNull}}
                        </li>
                        <li class="l-info-value">
                            {{'requests.clientData.details.vatRegistrationNumber' | translate}}:
                            {{associate.vatRegistrationNumber | replaceIfNull}}
                        </li>
                    </ul>
                </div>
            </div>

            <div *ngIf="clientDataRequest.dictionaryClientDataRequestType.code === typesEnum.PersonalInfo">
                <div class="l-section">
                    <span class="l-section-title">
                        {{'requests.clientData.details.personalInformation' | translate}}
                    </span>

                    <ul class="l-section-values">
                        <li HJSuppress class="l-info-value">
                            <span class="l-info-value-label">{{'requests.clientData.details.name' | translate}}:</span>
                            {{clientDataRequest.personalInformation.firstName | replaceIfNull}}
                            {{clientDataRequest.personalInformation.lastName | replaceIfNull}}
                        </li>
                        <li HJSuppress class="l-info-value">
                            <span class="l-info-value-label">{{'requests.clientData.details.newIdSeries' |
                                translate}}:</span> {{clientDataRequest.personalInformation.idSeries | replaceIfNull}}
                        </li>
                        <li HJSuppress class="l-info-value">
                            <span class="l-info-value-label">{{'requests.clientData.details.newIdNumber' |
                                translate}}:</span> {{clientDataRequest.personalInformation.idNumber | replaceIfNull}}
                        </li>
                        <li HJSuppress class="l-info-value">
                            <span class="l-info-value-label">{{'requests.clientData.details.issuedBy' |
                                translate}}:</span> {{clientDataRequest.personalInformation.issuedBy | replaceIfNull}}
                        </li>
                        <li HJSuppress class="l-info-value">
                            <span class="l-info-value-label">{{'requests.clientData.details.expiryDate' |
                                translate}}:</span> {{clientDataRequest.personalInformation.expiryDate | localizedDate}}
                        </li>
                    </ul>
                </div>
            </div>

            <div *ngIf="clientDataRequest.dictionaryClientDataRequestType.code === typesEnum.CompanyInfo">
                <div class="l-section">
                    <span class="l-section-title">{{'requests.clientData.details.information' | translate}}</span>

                    <ul class="l-section-values">
                        <li HJSuppress class="l-info-value">
                            {{clientDataRequest.companyInformation.name | replaceIfNull}}
                        </li>
                        <li HJSuppress class="l-info-value">
                            {{clientDataRequest.companyInformation.legalForm | replaceIfNull}}
                        </li>
                        <li HJSuppress class="l-info-value">
                            {{clientDataRequest.companyInformation.mainActivityField | replaceIfNull}}
                        </li>
                        <li HJSuppress class="l-info-value">
                            {{clientDataRequest.companyInformation.registrationCode | replaceIfNull}}
                        </li>
                    </ul>
                </div>
            </div>

            <div *ngIf="clientDataRequest.dictionaryClientDataRequestType.code === typesEnum.Other">
                <div class="l-section">
                    <span class="l-section-title">{{'requests.clientData.details.observation' | translate}}</span>

                    <ul class="l-section-values">
                        <li HJSuppress class="l-info-value l-info-observation">{{clientDataRequest.otherObservations |
                            replaceIfNull}}</li>
                    </ul>
                </div>
            </div>

            <div *ngIf="clientDataRequest.dictionaryClientDataRequestType.code === typesEnum.BankAccount">
                <div class="l-section">
                    <span class="l-section-title">{{'requests.clientData.newRequest.iban' | translate}}</span>

                    <ul class="l-section-values">
                        <li HJSuppress class="l-info-value">
                            {{clientDataRequest.iban | replaceIfNull}}
                        </li>
                    </ul>
                </div>

                <div class="l-section">
                    <span class="l-section-title">{{'requests.clientData.newRequest.bank' | translate}}</span>

                    <ul class="l-section-values">
                        <li HJSuppress class="l-info-value">
                            {{clientDataRequest.bank | replaceIfNull}}
                        </li>
                    </ul>
                </div>
            </div>

            <div class="l-section">
                <span class="l-section-title">{{'requests.details.category.dateOfRequest' | translate}}</span>

                <ul class="l-section-values">
                    <li HJSuppress class="l-info-value">{{clientDataRequest.createdOn | localizedDate}}</li>
                </ul>
            </div>
        </div>
    </div>
    }

    @case (REQUEST_DETAIL_CATEGORY.DOCUMENTS) {
    <request-documents [requestId]="clientDataRequest.clientDataRequestId"
        [requestTypeCode]="DICTIONARY_REQUEST_TYPES.CLIENT_DATA" [selectedCategory]="selectedCategory">
    </request-documents>
    }

    @case (REQUEST_DETAIL_CATEGORY.COMMENTS) {
    <div class="card">
        <div class="card-body">
            <request-comment [requestId]="clientDataRequest.clientDataRequestId"
                [requestTypeCode]="DICTIONARY_REQUEST_TYPES.CLIENT_DATA" [selectedCategory]="selectedCategory">
            </request-comment>
        </div>
    </div>
    }
    }
</div>